import styled, { keyframes } from 'styled-components'
import {
  mediaMax,
  calculateResponsiveSize
} from '@dboxdev/ui-components'

export const FADE_DURATION = 1000

const fadeIn = keyframes`
  from { opacity: 0; }
  to { opacity: 1; }
`

const fadeOut = keyframes`
  from { opacity: 1; }
  to { opacity: 0; }
`

export const Overlay = styled.div`
  position: fixed;
  inset: 0;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #000000;
  animation: ${({ $isClosing }) => ($isClosing ? fadeOut : fadeIn)} ${FADE_DURATION}ms ease forwards;
`

export const VideoBox = styled.div`
  position: relative;
  width: ${calculateResponsiveSize(1630)};
  aspect-ratio: 16 / 9;
  ${mediaMax('mobile')} {
    width: 100%;
  }
`

export const CloseButton = styled.button`
  position: absolute;
  top: ${calculateResponsiveSize(40)};
  right: ${calculateResponsiveSize(40)};
  width: ${calculateResponsiveSize(40)};
  height: ${calculateResponsiveSize(40)};
  padding: 0;
  border: 0;
  background: none;
  color: #d9d9d9;
  cursor: pointer;
  svg {
    display: block;
    width: 100%;
    height: auto;
  }
  &:hover {
    color: #ffffff;
  }
  ${mediaMax('mobile')} {
    top: ${calculateResponsiveSize(20)};
    right: ${calculateResponsiveSize(20)};
    width: ${calculateResponsiveSize(28)};
    height: ${calculateResponsiveSize(28)};
  }
`
